import AccountPageTemplate from 'components/shared/AccountPageTemplate'

import { FormattedMessage } from 'react-intl'

const ActivationLinkInvalid = () => (
    <AccountPageTemplate
        title={
            <FormattedMessage
                id="global.activation_link_error"
                defaultMessage="Wystąpił błąd"
            />
        }
        text={
            <FormattedMessage
                id="global.activation_link_invalid"
                defaultMessage="Link aktywacyjny jest nieprawidłowy."
            />
        }
        hasLoginInfoHidden
    />
)

export default ActivationLinkInvalid
